import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomReverseBannerComponent} from './custom-reverse-banner.component';
import {CustomCmsItemModule} from '../custom-cms-item/custom-cms-item.module';
import {CmsConfig, ConfigModule} from '@spartacus/core';


@NgModule({
  declarations: [CustomReverseBannerComponent],
  imports: [
    CommonModule,
    CustomCmsItemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ReverseBannerComponent: {
          component: CustomReverseBannerComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomReverseBannerModule { }
